import React from "react";

import { Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";

import i18n from "core/i18n";

export default function NotFeasible() {
    const { t } = i18n.useTranslation();

    return (
        <ContentBox mt={3}>
            <Typography variant={"b"}>{t("vehicle.change.notFeasible.edit")}</Typography>
        </ContentBox>
    );
}
